import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MessageService } from 'primeng/api';
import {FieldsetModule} from 'primeng/fieldset';

import { Fornecedor } from '../../fornecedor/models/fornecedor';
import { Evento } from '../models/evento';
import { EventoService } from '../evento.service';
import { FornecedorService } from '../../fornecedor/fornecedor.service';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';

@Component({
  selector: 'app-evento-detalhe',
  templateUrl: './evento-detalhe.component.html',
  styleUrls: ['./evento-detalhe.component.scss']
})
export class EventoDetalheComponent implements OnInit {

  public idEvento: number = 1;
  public evento: Evento;
  public isDisabled: boolean = false;
  public eventoFornecedores: Fornecedor[] = [];
  public data:  Date = new Date();
  public minDate:  Date = new Date();
  public submitted: boolean;
  //public listaEventoProduto: EventoProduto[] = [];  

  constructor(public eventoService: EventoService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private messageService: MessageService,
    public fornecedorService: FornecedorService
  ) { }


  ngOnInit(): void {    
    this.idEvento = parseInt(this.activateRoute.snapshot.paramMap.get("idEvento"));
    this.evento = this.activateRoute.snapshot.data['Evento'];    
    this.evento.dtIni = new Date(this.evento.dtIni);        
    this.evento.dtFim = new Date(this.evento.dtFim);   
    this.evento.dtLimiteEntrega = new Date(this.evento.dtLimiteEntrega);   
  }


  getEvento(idEvento: number) {

    this.eventoService.getEvento(idEvento).subscribe(
      (res) => {
        if (res) {
          this.evento = res;         
        }
      },
      err => {
        console.log("EventoDetalhe - Evento");
        console.log(err);
      }
    );
  } 

  BackEventoLista() {
    this.router.navigate(['/evento-list'])
  }

  saveEvento() {    

    //console.log(this.evento);

    if (this.evento.idEvento) {            
      this.eventoService
        .updEvento(this.evento)
        .subscribe(
          () => {            
            this.getEvento(this.evento.idEvento);
            this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Evento atualizado com sucesso!', life: 3000 });
          },
          err => {
            this.messageService.add({ severity: 'warning', summary: 'Erro', detail: 'Ocorreu um erro ao salvar as alterações. Erro:'+err, life: 10000 });
            console.log(err);
          }
        );
      
    } else {          
      this.eventoService
        .addEvento(this.evento)
        .subscribe(
          () => {
            this.getEvento(this.evento.idEvento);
            this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Fornecedor cadastrado com sucesso!', life: 3000 });
          },
          err => {
            this.messageService.add({ severity: 'warning', summary: 'Erro', detail: 'Ocorreu um erro ao salvar as alterações. Erro:'+err, life: 10000 });
            console.log(err)
          }
        );

      
    }    
  }
}